import { MAX_CURRENT_YEAR, MIN_CURRENT_YEAR } from 'spw-constants';

export const isValidCurrentYear = (year: string) => {
  const parsedYear = parseInt(year, 10);

  return parsedYear >= MIN_CURRENT_YEAR && parsedYear <= MAX_CURRENT_YEAR;
};
